import script from "./VideoPlayerArchive.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlayerArchive.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlayerArchive.vue?vue&type=style&index=0&id=4bd6de5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd6de5c"]])

export default __exports__